import { apiClientV1 } from './apiClient';

export default {
  getPastTour: (tourId, params) => apiClientV1.get(`/live/tours/${tourId}/past`, { params }),
  getAttachments: (tourId) => apiClientV1.get(`/live/tours/${tourId}/attachments`),
  getMessages: (tourId, params) => apiClientV1.get(`/live/tours/${tourId}/messages`, { params })
};
